import type { ReactNode } from "react";
import type { ToastProps } from "react-bootstrap";
import type { Variant } from "react-bootstrap/esm/types";

import classNames from "classnames";
import React from "react";
import { Toast, Button } from "react-bootstrap";
import { XLg } from "react-bootstrap-icons";

interface INotificationProps extends ToastProps {
  onClose?: () => void;
  message: string | ReactNode;
  isCloseBtn?: boolean;
  Icon?: ReactNode;
  bg?: Variant;
  textClassName?: string;
}

function Notification({
  onClose,
  message,
  isCloseBtn = true,
  Icon,
  bg = "body-color",
  textClassName = "text-body-bg",
  ...props
}: INotificationProps) {
  return (
    <Toast className="p-2 w-100 border-0" bg={bg} {...props}>
      <Toast.Body className="d-flex align-items-center">
        {Icon && (
          <div className="me-2 d-flex justify-content-center align-items-center">
            {Icon}
          </div>
        )}

        <div className={classNames("fs-7 flex-grow-1", textClassName)}>
          {message}
        </div>

        {isCloseBtn && (
          <Button
            variant="link"
            className={classNames(
              "p-0 ms-2 text-decoration-none text-info",
              textClassName
            )}
            onClick={onClose}
          >
            <XLg />
          </Button>
        )}
      </Toast.Body>
    </Toast>
  );
}

export default Notification;
